import { UnplugIcon } from "lucide-react";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "./empty";
import { Trans } from "@lingui/react/macro";

export default function Error({
  error,
  heading,
  description,
  className,
}: {
  heading?: string;
  description?: string;
  error?: Error | null;
  withBorder?: boolean;
  className?: string;
}) {
  return (
    <Empty className={className}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <UnplugIcon />
        </EmptyMedia>
        <EmptyTitle>{heading}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
        {error && (
          <EmptyDescription className="text-destructive select-text selection:bg-destructive selection:text-destructive-foreground">
            <Trans>Fel</Trans>: {error.message}
          </EmptyDescription>
        )}
      </EmptyHeader>
    </Empty>
  );
}
